<template>
  <div>
    <Button :icon="{ left: `trash-alt` }" @click="show = true">Delete </Button>
    <Modal :className="$style.modal" v-model="show" label="Are you sure?">
      <Stack direction="column">
        <TextComponent color="error" type="heading4" as="p"
          >Our boi ain't coming back after this...
        </TextComponent>
        <Stack>
          <Button :loading="loading" @click="remove">Do it! *Cocks gun*</Button>
          <Button @click="show = false" variant="outline"
            >Nevermind... *Puts gun away*
          </Button>
        </Stack>
      </Stack>
    </Modal>
  </div>
</template>

<script>
  import Button from '@hackthe6ix/vue-ui/Button';
  import Modal from '@hackthe6ix/vue-ui/Modal';
  import Stack from '@hackthe6ix/vue-ui/Stack';
  import TextComponent from '@hackthe6ix/vue-ui/Text';
  import swal from 'sweetalert';
  import 'vue-awesome/icons/trash-alt';
  import { deleteObject } from '../../../../../utils/api';

  export default {
  name: 'DeleteApplicant',
  props: {
    refetch: Function,
    data: Object,
  },
  data() {
    return {
      show: false,
      loading: false,
    };
  },
  methods: {
    async remove() {
      this.loading = true;

      const result = await deleteObject('user', {
        _id: this.$route.params.id,
      });

      if (result.success && result.data.length > 0) {
        this.show = false;

        swal('Success', 'Our boi is gone', 'success').then(() => {
          this.$router.push('/app');
        });
      } else {
        this.show = false;
        swal('Error', 'Invalid User', 'error');
      }
    },
  },
  components: {
    TextComponent,
    Button,
    Stack,
    Modal,
  },
};
</script>

<style lang="scss" module src="./DeleteApplicant.module.scss" />
